import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  resolvedComment: {
    id: 'frontbucket.conversation.resolvedCommentMessage',
    description: 'Message to indicate that a user resolved a comment',
    defaultMessage: 'resolved this comment thread.',
  },
});
